import { faArrowLeftLong, faCircleNotch, faTrashCan } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { Component } from 'react'
import JoditEditor from 'jodit-react';
import { isValidForm } from '../../utils/validation/CommonValidator';
import AdminServices from '../../services/axiosServices/apiServices/adminServices';
import SwalServices from '../../services/swalServices/SwalServices';
import { Navigate } from 'react-router-dom';
import ValidationText from '../../utils/validation/ValidationText';
import { CommonSuccessMessages, CommonValidationMessages } from '../../utils/Messages';
import MultiSelectDropdown from '../../components/dropdown/MultiSelectDropdown';
import { APIURL, UploadImage } from '../../services/axiosServices/ApiEndPoints';
import { getAuthProps } from '../../utils/AuthenticationLibrary';

let loginUser = getAuthProps();

export default class BlogDetails extends Component {
    constructor(props) {
        super(props);
        this.swalServices = new SwalServices();
        this.adminServices = new AdminServices();
        this.editorRef = React.createRef();
        this.state = {
            newsblogsid: 0,
            typeOption: [
                { label: "News", value: 1 },
                { label: "Blog", value: 2 },
            ],
            blogForm: {
                content: "",
                title: "",
                description: "",
                category: 1,
                bannerimage: null,
                bannerPreview: '',
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                title: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "title"),
                    },
                ],
                bannerimage: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "banner image"),
                    },
                ],
                content: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "content"),
                    },
                ],
                description: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "description"),
                    },
                ],
            }
        };
        this.editorConfig = {
            height: 600,
            placeholder: 'Enter blog content here...',
            readonly: false,
            toolbarSticky: false,
            buttons: [
                'source', '|',
                'bold', 'italic', 'underline', 'strikethrough', '|',
                'superscript', 'subscript', '|',
                'ul', 'ol', '|',
                'indent', 'outdent', '|',
                'align', 'font', 'fontsize', '|',
                'brush', 'paragraph', '|',
                'classSpan', 'spellcheck', '|',
                'link', 'image', 'video', '|',
                'table', 'hr', '|',
                'copyformat', 'cut', 'copy', 'paste', '|',
                'undo', 'redo', '|',
                'selectall', 'removeformat', '|',
                'fullsize', 'preview', 'print'
            ],
            uploader: {
                insertImageAsBase64URI: true,
                imagesExtensions: ['jpg', 'png', 'jpeg'],
                url: APIURL + UploadImage,
                format: 'json',
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${loginUser.token}`,
                },
                isSuccess: (resp) => resp && resp.success === 1,
                getMessage: (resp) => resp.msg || 'Upload failed',
                process: (resp) => {
                    return resp.files[0].url;
                }
            },
            uploaderInsertImageAsBase64URI: false,
            dragAndDrop: true,
            allowResizeX: true,
            allowResizeY: true
        };


    }


    componentDidMount() {
        let params = new URLSearchParams(window.location.search);
        let newsblogsid = Number(params.get(""))
        if (newsblogsid) {
            if (newsblogsid != null && newsblogsid > 0) {
                this.setState({ newsblogsid: newsblogsid }, () => {
                    this.getNewsBlogsData(this.state.newsblogsid)
                });
            }
        }
    }

    getNewsBlogsData = (id) => {
        this.adminServices.getNewsBlogsData(id).then((response) => {
            if (response.success === 1 && response.data !== null) {
                let res = response.data[0];

                let details = this.state.blogForm
                details.content = res.content
                details.bannerimage = res.bannerimage
                details.bannerPreview = res.bannerimage
                details.title = res.title
                details.description = res.description
                details.category = this.state.typeOption.find(x => x.label === res.category).value
                this.setState({ blogForm: details });
            } else {
                this.swalServices.Error(response.msg);
            }
        });
    }

    handleJobDescriptionChange = (newContent) => {
        this.setState(prevState => ({
            blogForm: {
                ...prevState.blogForm,
                content: newContent
            }
        }));
    };


    handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const imageUrl = URL.createObjectURL(file);
            let deatils = this.state.blogForm
            deatils.bannerimage = file
            deatils.bannerPreview = imageUrl
            this.setState({ bannerimage: deatils });
        }
    };

    handleSelectChange = (selectedOptions, name) => {
        let blogForm = this.state.blogForm
        blogForm[name] = selectedOptions.value
        this.setState({ blogForm: blogForm });
    };

    createNewsBlogs = () => {
        let isValidAllFields = this.isValidAllFields()
        if (isValidAllFields) {
            let details = this.state.blogForm;
            let formData = new FormData();
            formData.append("categoryId", details.category);
            formData.append("title", details.title);
            formData.append("description", details.description);
            formData.append("bannerImage", details.bannerimage);
            formData.append("content", details.content);
            this.setState({ isLoading: true })
            this.adminServices.createNewsBlogs(formData).then((response) => {
                if (response.success === 1) {
                    this.setState({ route: "/blogs" })
                    this.swalServices.Success(response.msg)
                } else {
                    this.swalServices.Error(response.msg)
                }
                this.setState({ isLoading: false });
            });
        }
    }

    updateNewsBlogs = () => {
        let isValidAllFields = this.isValidAllFields()
        if (isValidAllFields) {
            let details = this.state.blogForm;
            let formData = new FormData();
            formData.append("categoryId", details.category);
            formData.append("title", details.title);
            formData.append("description", details.description);
            formData.append("bannerImage", details.bannerimage);
            formData.append("content", details.content);
            this.setState({ isLoading: true })
            this.adminServices.updateNewsBlogs(formData, this.state.newsblogsid).then((response) => {
                if (response.success === 1) {
                    this.setState({ route: "/blogs" })
                    this.swalServices.Success(response.msg)
                } else {
                    this.swalServices.Error(response.msg)
                }
                this.setState({ isLoading: false });
            });
        }
    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.blogForm,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.blogForm;
        details[name] = value;
        this.setState({ blogForm: details });
    };

    handleDelete = () => {
        this.swalServices.Confirm(
            "",
            ``,
            CommonSuccessMessages.Yes_Text,
            CommonSuccessMessages.No_Text,
            `Are you sure you want to delete ?`
        ).then((response) => {
            if (response === true) {
                this.adminServices.deleteNewsBlogs(this.state.newsblogsid).then((response) => {
                    if (response.success === 1) {
                        this.swalServices.Success(response.msg);
                        setTimeout(() => {
                            this.setState({ route: "/blogs" })
                        }, 1000);
                    } else {
                        this.swalServices.Error(response.msg)
                    }
                    this.setState({ isLoading: false });
                });
            }
        });
    };

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='blog-details'>
                <div className='blog-details-inner p-[30px] overflow-y-auto' style={{ height: "calc(100vh - 168.8px)" }}>
                    <div className='title flex items-center justify-between mb-[10px]'>
                        <h1 className='text-[22px] m-0 font-semibold text-[#004AAD]' style={{ lineHeight: "30px" }}>
                            {this.state.newsblogsid > 0 ? 'Update' : 'Create'} Blog
                        </h1>
                        {/* <button className='flex items-center gap-[5px] py-[5px] px-[10px] text-[14px] font-medium rounded-[5px]'><FontAwesomeIcon className='w-5 h-5' icon={faUserPlus} />Add user</button> */}
                    </div>
                    <div className='blog-data'>
                        <div className='blog-data-inner'>

                            <div className='blog-details grid grid-cols-3 gap-[30px]'>
                                <div className='blog-details-left col-span-2'>
                                    <div className='blog-title p-5 bg-white rounded-[16px] mb-[30px]' style={{ border: "1px solid #DFDFDF" }}>
                                        <div className='input-grp !mb-0 col-span-2'>
                                            <h2 className='text-[16px] font-semibold mt-0 mb-2.5'>Blog title:</h2>
                                            <input
                                                type='text'
                                                placeholder='Enter title'
                                                id='title'
                                                name='title'
                                                className={`${this.state.validState?.error?.title ? "error" : ""}`}
                                                value={this.state.blogForm.title}
                                                onChange={(event) => this.handleChange(event, "title")}
                                            />
                                            <ValidationText error={this.state.validState.error.title} />
                                        </div>
                                    </div>
                                    <div className='blog-description p-5 bg-white rounded-[16px] mb-[30px]' style={{ border: "1px solid #DFDFDF" }}>
                                        <div className='input-grp !mb-0 col-span-2'>
                                            <h2 className='text-[16px] font-semibold mt-0 mb-2.5'>Blog description:</h2>
                                            <textarea
                                                rows={2}
                                                type='text'
                                                placeholder='Enter description'
                                                id='description'
                                                name='description'
                                                className={`${this.state.validState?.error?.description ? "error" : ""}`}
                                                value={this.state.blogForm.description}
                                                onChange={(event) => this.handleChange(event, "description")}
                                            />
                                            <ValidationText error={this.state.validState.error.description} />
                                        </div>
                                    </div>
                                    <div className='blog-content border border-gray-300 rounded-0 overflow-hidden p-5 bg-white rounded-[16px]' style={{ border: "1px solid #DFDFDF" }}>
                                        <h2 className='text-[16px] font-semibold mt-0 mb-2.5'>Blog content: </h2>
                                        <JoditEditor
                                            ref={this.editorRef}
                                            value={this.state.blogForm.content}
                                            onBlur={(newContent) => this.handleJobDescriptionChange(newContent)}
                                            onChange={() => { }}
                                            tabIndex={1}
                                            className={`${this.state.validState?.error?.content ? "error" : ""}`}
                                            config={this.editorConfig}
                                        />
                                    </div>
                                </div>
                                <div className='blog-detials-right'>
                                    <div className='blog-img p-5 bg-white rounded-[16px] mb-[30px]' style={{ border: "1px solid #DFDFDF" }}>
                                        <h2 className='text-[16px] font-semibold mt-0 mb-2.5'>Blog Image</h2>
                                        <input
                                            type='file'
                                            accept='image/*'
                                            onChange={this.handleImageChange}
                                            className={`${this.state.validState?.error?.bannerimage ? "error" : ""}`}
                                        />
                                        {this.state.blogForm.bannerPreview && (
                                            <img
                                                src={this.state.blogForm.bannerPreview}
                                                alt='Preview'
                                                className={`mt-4 w-full rounded-[10px] object-cover `}
                                                style={{ maxHeight: "300px" }}
                                            />
                                        )}
                                    </div>
                                    <div className='blog-category p-5 bg-white rounded-[16px]' style={{ border: "1px solid #DFDFDF" }}>
                                        <h2 className='text-[16px] font-semibold mt-0 mb-2.5'>Select category</h2>
                                        <MultiSelectDropdown
                                            options={this.state.typeOption}
                                            onChange={(selected) => this.handleSelectChange(selected, 'category')}
                                            closeMenuOnSelect={true}
                                            hideSelectedOptions={false}
                                            value={this.state.typeOption.filter(item => item.value === this.state.blogForm.category)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='sticky bottom-0 bg-white border-t border-slate-200 z-30 px-[30px] py-[30px] flex items-center justify-between' style={{ borderTop: "1px solid rgb(0,0,0,0.1)", boxShadow: "0 -7px 12px -6px rgb(14, 63, 126, 0.04)" }}>
                    <div className='btn-left'>
                        <button
                            onClick={() => { this.setState({ route: "/blogs" }) }}
                            className='font-medium text-[16px] text-[#223645] leading-[24px] px-[24px] py-[12px] rounded-[14px] bg-[#EBEBEB] hover:bg-[#dddddd] border-0 flex items-center gap-[5px]'>
                            <FontAwesomeIcon icon={faArrowLeftLong} className='w-5 h-5' />Back
                        </button>
                    </div>
                    <div className='btn-right flex items-center gap-5'>
                        {this.state.newsblogsid > 0 ?
                            <>
                                <button
                                    onClick={() => this.handleDelete()}
                                    className='font-medium text-[16px] text-[#EA3636] hover:text-[#ffffff] leading-[24px] px-[24px] py-[12px] rounded-[14px] border-0 bg-[#ffe8e8] hover:bg-[#EA3636] flex items-center gap-[5px]'>
                                    <FontAwesomeIcon icon={faTrashCan} className='w-5 h-5' />Delete
                                </button>
                                <button
                                    onClick={() => this.updateNewsBlogs()}
                                    className='font-medium text-[16px] text-[#FFFFFF] leading-[24px] px-[24px] py-[12px] rounded-[14px] bg-[#0077B6] hover:bg-[#3b82f6] border-0'>
                                    {this.state.isLoading ? <FontAwesomeIcon icon={faCircleNotch} spin /> : "Update"}
                                </button>
                            </>
                            :
                            <button
                                onClick={() => this.createNewsBlogs()}
                                className='font-medium text-[16px] text-[#FFFFFF] leading-[24px] px-[24px] py-[12px] rounded-[14px] bg-[#0077B6] hover:bg-[#3b82f6] border-0'>
                                {this.state.isLoading ? <FontAwesomeIcon icon={faCircleNotch} spin /> : "Save"}
                            </button>
                        }

                    </div>
                </div>
            </div>
        )
    }
}
